import { useEffect, useState } from "react";

function useLoadingMessage() {
  const [loadingMessage, updateLoadingMessage] = useState("SUNAT");

  useEffect(() => {
    // Define next message.
    let newMessage;
    switch (loadingMessage) {
      case "SUNAT":
        newMessage = "base de datos";
        break;
      case "base de datos":
        newMessage = "TALMA";
        break;
      case "TALMA":
        newMessage = "SUNAT";
        break;
      default:
        newMessage = "";
        break;
    }
    // Update it after a fix amount of ms.
    const id = setTimeout(() => {
      updateLoadingMessage(newMessage);
    }, 1500);
    // Remove pending timeout when unmounting the component.
    return () => clearInterval(id);
  }, [loadingMessage]);

  return loadingMessage;
}

export default useLoadingMessage;
